/* Request homepage media near the viewport; original HD URLs stay intact. */
(function () {
  'use strict';
  function prepare(image) {
    var src = image.getAttribute('data-earthle-home-src');
    if (!src) return;
    image.classList.add('e-home-image-pending');
    function ready() { image.classList.remove('e-home-image-pending'); }
    image.addEventListener('load', ready, { once: true });
    image.addEventListener('error', ready, { once: true });
    image.decoding = 'async';
    image.loading = 'eager';
    image.fetchPriority = 'low';
    var srcset = image.getAttribute('data-earthle-home-srcset');
    if (srcset) image.setAttribute('srcset', srcset);
    image.setAttribute('src', src);
    image.removeAttribute('data-earthle-home-src');
    image.removeAttribute('data-earthle-home-srcset');
    if (image.complete && image.naturalWidth) ready();
  }
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      prepare(entry.target);
      // Warm the next slide before a swipe or autoplay transition reveals it.
      var slide = entry.target.closest('[data-ps-slide]');
      var next = slide && slide.nextElementSibling;
      if (next) next.querySelectorAll('img[data-earthle-home-src]').forEach(prepare);
    });
  }, { rootMargin: '150px 0px' }) : null;
  function init(root) {
    root.querySelectorAll('img[data-earthle-home-src]').forEach(function (image) {
      if (observer) observer.observe(image);
      else prepare(image);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
